export class TransactionQuickEntryModel {
      public AccountCodeQuickEntryAutoCompleteDr:any;
       public AccountCodeQuickEntryAutoCompleteCr:any;
        public AccountCodeQuickEntryAutoCompleteNarration:any;

    public ExpenseQuickEntryID: number;

    public ExpenseQuickEntryName: string;
    public ExpenseQuickEntryFullName: string;

    public CategoryID: number;
       public AccountCodeDr :string;
        public AccountNameDr:string;
        public AccountCodeCr :string;
        public AccountNameCr:string;
        public AccountCodeNarration :string;
        public AccountNameNarration:string;
        public Narration:string;
        public ProductIDAutoComplete:string;
        public ProductID:number;
        public ProductName:string;  
}
